import { createPortal } from 'react-dom';
import { Box } from '@mui/material';
import { useWatch } from 'react-hook-form';

import { useDisclosure } from '@hooks/useDisclosure';
import { RemarkButton } from '@Components/IconButton';
import Remark from '@Components/Remark';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import {
  IGreenhouseGasOtherFormValues,
  IGreenhouseGoalTermFormValues,
} from '../../EsgGreenhouseFormProvider/types';

export const GH_GAS_REMARK_ID = 'gh-gas-remark';

const OtherGreenhouseGasRemark = () => {
  const { control, getValues } = useGreenhouseForm();

  const { remark } =
    getValues('greenhouseGoalTerm.other') ??
    ({} as IGreenhouseGasOtherFormValues);
  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const remarkEl = document.getElementById(GH_GAS_REMARK_ID);

  const { completedSection } =
    useWatch({ name: 'greenhouseGoalTerm', control }) ??
    ({} as IGreenhouseGoalTermFormValues);

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        remarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              topic="การตั้งเป้าหมายการลดก๊าซเรือนกระจกอื่น ๆ"
              fieldPath="greenhouseGoalTerm.other.remark"
              setOpen={open}
              onDelete={close}
              isCompletedTh={isCompletedTh}
              isCompletedEn={isCompletedEn}
            />
          </Box>,
          remarkEl
        )}
    </>
  );
};

export default OtherGreenhouseGasRemark;
